import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fetchPlatformTenant, setContractTerms } from "../../lib/opsGraphql";

const EMPTY_FORM = {
  monthly_fee_ars: "",
  implementation_fee_ars: "",
  implementation_fee_split: "50_50",
  billing_currency: "ARS",
  fx_reference: "BNA_vendedor",
  fair_use_cap_docs_monthly: "",
  copilot_included: false,
  arca_validation_included: true,
  quality_review_clause_active_from: "",
  quality_review_clause_status: "pending",
  contract_annex_ref: "",
  notes: "",
};

export default function TenantContractTermsForm() {
  const { tenantId } = useParams();
  const [form, setForm] = useState(EMPTY_FORM);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");

  useEffect(() => {
    if (!tenantId) return;
    setLoading(true);
    fetchPlatformTenant(tenantId)
      .then((detail) => {
        const terms = detail?.contract_terms;
        if (terms) {
          setForm({
            monthly_fee_ars: terms.monthly_fee_ars ?? "",
            implementation_fee_ars: terms.implementation_fee_ars ?? "",
            implementation_fee_split: terms.implementation_fee_split || "50_50",
            billing_currency: terms.billing_currency || "ARS",
            fx_reference: terms.fx_reference || "",
            fair_use_cap_docs_monthly: terms.fair_use_cap_docs_monthly ?? "",
            copilot_included: !!terms.copilot_included,
            arca_validation_included: !!terms.arca_validation_included,
            quality_review_clause_active_from: terms.quality_review_clause_active_from || "",
            quality_review_clause_status: terms.quality_review_clause_status || "pending",
            contract_annex_ref: terms.contract_annex_ref || "",
            notes: terms.notes || "",
          });
        } else {
          setForm(EMPTY_FORM);
        }
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [tenantId]);

  const onChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setInfo("");
    try {
      await setContractTerms({
        tenant_id: tenantId,
        monthly_fee_ars: form.monthly_fee_ars ? Number(form.monthly_fee_ars) : null,
        implementation_fee_ars: form.implementation_fee_ars ? Number(form.implementation_fee_ars) : null,
        implementation_fee_split: form.implementation_fee_split,
        billing_currency: form.billing_currency,
        fx_reference: form.fx_reference,
        fair_use_cap_docs_monthly: form.fair_use_cap_docs_monthly
          ? Number(form.fair_use_cap_docs_monthly)
          : null,
        copilot_included: form.copilot_included,
        arca_validation_included: form.arca_validation_included,
        quality_review_clause_active_from: form.quality_review_clause_active_from || null,
        quality_review_clause_status: form.quality_review_clause_status,
        contract_annex_ref: form.contract_annex_ref,
        notes: form.notes,
      });
      setInfo("Términos contractuales guardados.");
    } catch (err) {
      setError(err.message || "No se pudieron guardar los términos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <p>
        <Link to={`/tenants/${tenantId}`}>← Volver a ficha</Link>
      </p>
      <div className="ops-card">
        <h2>Términos contractuales — {tenantId}</h2>
        {error && <p className="ops-error">{error}</p>}
        {info && <p className="ops-info">{info}</p>}
        <form className="ops-form-grid" onSubmit={onSubmit}>
        <label>
          Tarifa mensual (ARS)
          <input type="number" value={form.monthly_fee_ars} onChange={onChange("monthly_fee_ars")} />
        </label>
        <label>
          Fee implementación (ARS)
          <input type="number" value={form.implementation_fee_ars} onChange={onChange("implementation_fee_ars")} />
        </label>
        <label>
          Split implementación
          <input value={form.implementation_fee_split} onChange={onChange("implementation_fee_split")} />
        </label>
        <label>
          Moneda
          <input value={form.billing_currency} onChange={onChange("billing_currency")} />
        </label>
        <label>
          Referencia FX
          <input value={form.fx_reference} onChange={onChange("fx_reference")} />
        </label>
        <label>
          Cap fair-use docs/mes
          <input type="number" value={form.fair_use_cap_docs_monthly} onChange={onChange("fair_use_cap_docs_monthly")} />
        </label>
        <label>
          Revisión calidad desde
          <input type="date" value={form.quality_review_clause_active_from} onChange={onChange("quality_review_clause_active_from")} />
        </label>
        <label>
          Estado cláusula revisión
          <select value={form.quality_review_clause_status} onChange={onChange("quality_review_clause_status")}>
            <option value="pending">pending</option>
            <option value="active">active</option>
            <option value="waived">waived</option>
          </select>
        </label>
        <label>
          Referencia Annex
          <input value={form.contract_annex_ref} onChange={onChange("contract_annex_ref")} />
        </label>
        <label>
          <span>Copilot incluido</span>
          <input type="checkbox" checked={form.copilot_included} onChange={onChange("copilot_included")} />
        </label>
        <label>
          <span>ARCA incluido</span>
          <input type="checkbox" checked={form.arca_validation_included} onChange={onChange("arca_validation_included")} />
        </label>
        <label style={{ gridColumn: "1 / -1" }}>
          Notas
          <textarea rows={3} value={form.notes} onChange={onChange("notes")} />
        </label>
        <div style={{ gridColumn: "1 / -1" }}>
          <button type="submit" className="ops-btn" disabled={loading || !tenantId}>
            Guardar términos
          </button>
        </div>
        </form>
      </div>
    </>
  );
}
